export default "__VITE_ASSET__BzTfXufe__"